module.exports = __webpack_public_path__ + "static/media/bg-photo.46bbbea8.png";